import * as R from 'ramda';

import { PriceDistributionTrimPercentage } from 'ha/pages/Search/constants';

import reformatPriceDistribution from './reformatPriceDistribution';
import getPriceDistribution, {
  PriceDistributionArgs,
} from './getPriceDistribution';

export default ({
  pricesFacet,
  minPrice,
  maxPrice,
  rate,
}: PriceDistributionArgs) => {
  const priceDistribution = reformatPriceDistribution(
    getPriceDistribution({
      pricesFacet,
      minPrice,
      maxPrice,
      rate,
    }),
  );

  // Get value for last included range (limit).
  const limitValue =
    (1 - PriceDistributionTrimPercentage / 100) *
    R.reduce((a, b) => a + b.value, 0, priceDistribution);

  let accumValue = 0;
  // Get first index of value that covers the limit.
  const limitIndex = R.findIndex(bucket => {
    accumValue += bucket.value;

    return accumValue >= limitValue;
  }, priceDistribution);
  const nextIndex =
    limitIndex + 1 < priceDistribution.length ? limitIndex + 1 : limitIndex;

  const trimmedPriceMin = minPrice;
  const trimmedPriceMax = priceDistribution[nextIndex].range;

  return getPriceDistribution({
    pricesFacet,
    minPrice: trimmedPriceMin,
    maxPrice: trimmedPriceMax,
    rate,
  });
};
